import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { AppliedToplineItem, NoteDetailsFragment, NoteTarget } from 'generated/graphql';

import { NoteDialogComponent } from 'app/note/dialogs/note-dialog/note-dialog.component';

@Component({
  selector: 'app-topline-note',
  templateUrl: './topline-note.component.html',
  styleUrls: ['./topline-note.component.scss']
})
export class ToplineNoteComponent  {
  @Input() topline: Partial<AppliedToplineItem> | any;

  @Input() targetId: string;
  @Input() targetType: 'Entity' | 'EntityConnection';
  @Input() campaignId: string;

  /** Will be used for top topline */
  @Input() truncate: boolean;
  @Output() addClick = new EventEmitter<any>();

  constructor(private _matDialog: MatDialog
  ) { }


  onAddClicked() {
    const eventData = {
      targetType: this.targetType,
      targetId: this.targetId,
      topline: this.topline,
    };
    this.addClick.emit(eventData);
  }

  viewAllNotesClicked(note: NoteDetailsFragment) {
    NoteDialogComponent.open(this._matDialog, {
      data: {
        campaignId: this.campaignId,
        targetId: this.targetId,
        targetType: this.targetType as NoteTarget,
        noteType: 'text',
        heading: 'View Notes',
        hideNotes: false
      }
    });
  }


}
